module.exports = __webpack_public_path__ + "img/image-022.e89c9409.png";